import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let frame = requestAnimationFrame(function raf(time) {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    });
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      if (window.__lenis === lenis) window.__lenis = null;
    };
  }, []);
};

const scrollToHash = (hash) => {
  const target = document.getElementById(hash.slice(1));
  if (!target) return;
  if (window.__lenis) window.__lenis.scrollTo(target, { offset: -112, immediate: true });
  else target.scrollIntoView({ behavior: "instant", block: "start" });
};

export const useRouteScroll = () => {
  const { pathname, hash, key } = useLocation();
  const previousPath = useRef(null);
  useEffect(() => {
    const changedPage = previousPath.current !== pathname;
    previousPath.current = pathname;
    if (hash) {
      const frame = requestAnimationFrame(() => scrollToHash(hash));
      return () => cancelAnimationFrame(frame);
    }
    if (changedPage) {
      window.__lenis?.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, key]);
};